import { createAction } from 'redux-actions'

const RESET_SETTINGS = 'RESET_SETTINGS'
const SET_LANGUAGE = 'SET_LANGUAGE'
const SET_TIMEZONE = 'SET_TIMEZONE'

const actions = {
    resetSettings: createAction(RESET_SETTINGS),
    setLanguage: createAction(SET_LANGUAGE),
    setTimezone: createAction(SET_TIMEZONE)
}

const types = {
    RESET_SETTINGS,
    SET_LANGUAGE,
    SET_TIMEZONE
}

export { actions, types }



// WEBPACK FOOTER //
// ./src/store/actions/settings.js